import React, { useEffect, useState } from 'react';
import { message, DatePicker, Form, Input, Select } from "antd";
import { Button } from "evergreen-ui";
import FireFetch from "../../Firebase/FireFetch";
import Firebase from "../../Firebase/Firebase";
import { useListVals } from "../../Firebase/databaseHooks";
import { getDatabase, ref } from "firebase/database";
import { getStorage, ref as storageRef, uploadBytes } from "firebase/storage";
import { v4 as uuidv4 } from 'uuid';
import { useAuth } from "../../AuthContext/AuthContext";
import { filterSelectOption, sortSelectOptions } from "../../utils/selectOptions.js";

const { TextArea } = Input;
var storage = getStorage(Firebase);
var db = getDatabase(Firebase);
const moment = require("moment");
const AddInteraction = (props) => {
  const { canAccessModule, firebaseUser } = useAuth();
  const canCreateInteraction = canAccessModule("INTERACTIONS", "create");

  const [filesList, setFilesList] = useState([]);
  const [folderID, setFolderID] = useState(null);
  const [showLoading, setShowLoading] = useState(false);
  const [organizationArray] = useListVals(ref(db, "talmidsdb/organisations"));
  const [communityArray] = useListVals(ref(db, "talmidsdb/communities"));
  const [userArray] = useListVals(ref(db, "talmidsdb/users"));
  const [lessonArray] = useListVals(ref(db, "talmidsdb/lessons"));
  const [consents] = useListVals(ref(db, "talmidsdb/consents"));
  const [date, setDate] = useState(null);
  const [commArray, setCommArray] = useState([]);
  const [specify, setSpecify] = useState(false);
  const ownConsents = (consents || []).filter((consent) => {
    const ownerId =
      consent.createdBy ||
      consent.addedByUser ||
      consent.submitedByuserID ||
      consent.submittedByUserID ||
      consent.userID ||
      consent.id;
    return ownerId === firebaseUser?.uid;
  });

  function onChangeTwo(date, dateString) {
    setDate(dateString);
  }

  const handleComm = (option) => {
    console.log(option);
    if (option === "other") {
      setSpecify(true);
    }
    else {
      setSpecify(false);
    }
  }

  useEffect(() => {
    if (userArray) {
      var tempArray = [];
      userArray.map((user) => {
        var commObject = {
          name: user.firstname + " " + user.surname,
          id: user.id,
        }

        tempArray.push(commObject);
      });
      tempArray.push({ name: "Other", id: "other" });
      setCommArray([...tempArray]);
    }
  }, [userArray]);

  const handleFileUpload = (e) => {
    console.log(e.target.id);
    const fileObject = {
      "fileID": e.target.id,
      "file": e.target.files[0]
    }
    if (!filesList.includes(fileObject)) {
      var index = filesList.findIndex(x => x.fileID === fileObject.fileID);
      console.log(index);
      if (index != -1) {
        filesList.splice(index, 1);
        setFilesList(filesList => [...filesList, fileObject]);
      } else {
        setFilesList(filesList => [...filesList, fileObject]);
      }
    }
  }

  const addFile = (fileObject) => {
    console.log(fileObject.folderID);

    uploadBytes(storageRef(storage, "talmidsdb/Interactions/" + fileObject.folderID + "/" + fileObject.fileID),
      fileObject.file).then(function (snapshot) {
        console.log('Uploaded a blob or file!');
      });
  }

  const functionWithPromise = object => {
    addFile(object);
  }

  const anAsyncFunction = async item => {
    return functionWithPromise(item)
  }
  const addImageArray = async (list) => {
    return await Promise.all(list.map(item => anAsyncFunction(item)))
  }

  const handleCreate = (values) => {
    if (!canCreateInteraction) {
      message.error("You do not have permission to create interactions.");
      return;
    }

    setShowLoading(true);
    var timeStamp = moment().format("YYYY-MM-DDTh:mm:ss");
    var objectID = uuidv4();

    setFolderID(objectID);
    var interactionObject = {
      "interactionType": values.interactionType ? values.interactionType : "",
      "countMales": values.countMales ? values.countMales : "",
      "countFemales": values.countFemales ? values.countFemales : "",
      "countChildrenYouth": values.countChildrenYouth ? values.countChildrenYouth : "",
      "notes": values.notes ? values.notes : "",
      "commitments": values.commitments ? values.commitments : "",
      "countDisability": values.countDisability ? values.countDisability : "",
      "countElderly": values.countElderly ? values.countElderly : "",
      "dateTime": values.dateTime ? values.dateTime.format("YYYY-MM-DDTh:mm") : "",
      "lessonId": values.lessonId ? values.lessonId : "",
      "communityID": values.communityID ? values.communityID : "",
      "organisationID": values.organisationID ? values.organisationID : "",
      "userId": firebaseUser?.uid || "",
      "userID": values.worker ? values.worker : "",
      "id": objectID,
      "timeStamp": timeStamp,
      "communicatedWithId": (values.communicatedWithId ? values.communicatedWithId : ""),
      "consentID": values.consentID ? values.consentID : "",
    }

    if (values.communicatedName !== "" || values.communicatedName !== undefined) {
      interactionObject.communicatedWithOther = values.communicatedName
    }

    Object.entries(interactionObject).forEach(([key, value]) => {
      if (value === undefined) {
        interactionObject[key] = "";
      }
    });

    filesList.map((file) => {
      file.folderID = objectID;
    })


    addImageArray(filesList)
      .then((r) => {
        const output = FireFetch.SaveTODB("interactions", objectID, interactionObject);
        output.then((result) => {
          console.log(result);
          if (result === "success") {
            FireFetch.addLog("interactions", objectID, "Create");
            message.success("Interaction added successfully");
            props.modal(false);
            setSpecify(false);
            setShowLoading(false);
          } else {
            message.error("Unable to add interaction and error occurred :: " + result);
            setShowLoading(false);
            setSpecify(false);
          }
        })
          .catch((error) => {
            message.error("Unable to add interaction and error occurred :: " + error);
            setShowLoading(false);
            setSpeci
          });
      }).catch((err) => {
        message.error("Unable to add interaction and error occurred :: " + err);
        setShowLoading(false);
        setSpecify(false);
      })
  }

  return (
    <>
      <Form layout={"vertical"}
        onFinish={handleCreate}>
        <Form.Item label="Interaction Type"
          name="interactionType"
          rules={[{ required: true, message: 'Choose interaction type!' }]}>
          <Select placeholder="Select Interaction Type"
            showSearch
            optionFilterProp="children"
            filterOption={filterSelectOption}
            filterSort={sortSelectOptions}>
            {[{ label: "Whatsapp Or Text" }, { label: "Taught lesson" },
            { label: "Visit Or Meeting" }, { label: "Phone Call" }].map((item, index) => (
              <Select.Option value={item.label}>{item.label}</Select.Option>
            ))}

          </Select>
        </Form.Item>
        <Form.Item label="Lesson"
          name="lessonId">
          <Select placeholder="Select Lesson"
            showSearch
            optionFilterProp="children"
            filterOption={filterSelectOption}
            filterSort={sortSelectOptions}>
            {lessonArray.map((item, index) => (
              <Select.Option key={index} value={item.id}>{item.lessonName}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Organization"
          name="organisationID"
          rules={[{ required: true, message: 'Choose Organization!' }]}>
          <Select placeholder="Select organisation"
            showSearch
            optionFilterProp="children"
            filterOption={filterSelectOption}
            filterSort={sortSelectOptions}>
            {organizationArray.map((item, index) => (
              <Select.Option key={index} value={item.id}>{item.name}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Community"
          name="communityID"
          rules={[{ required: true, message: 'Choose Community!' }]}>
          <Select placeholder="Select community"
            showSearch
            optionFilterProp="children"
            filterOption={filterSelectOption}
            filterSort={sortSelectOptions}>
            {communityArray.map((item, index) => (
              <Select.Option key={index} value={item.id}>{item.name}</Select.Option>
            ))}

          </Select>
        </Form.Item>
        <Form.Item label="Communicated With"
          name="communicatedWithId">
          <Select placeholder="Select who the interaction was with"
            showSearch
            optionFilterProp="children"
            filterOption={filterSelectOption}
            filterSort={sortSelectOptions} onChange={handleComm}>
            {commArray.map((item, index) => (
              <Select.Option key={index} value={item.id}>{item.name}</Select.Option>
            ))}

          </Select>
        </Form.Item>
        <Form.Item label="Consent" name="consentID">
          <Select
            placeholder="Select consent"
            showSearch
            optionFilterProp="children"
            filterOption={filterSelectOption}
          >
            {ownConsents.map((item, index) => (
              <Select.Option key={index} value={item.id}>
                {item.childrenNames || item.childrenName || item.fullName || item.id}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Communicated With Other"
          name="communicatedWithOther">
          <Input placeholder="Enter the fullName of communicated with other" id="" />
        </Form.Item>
        <Form.Item label="Worker"
          name="worker"
          rules={[{ required: true, message: 'Choose Worker!' }]}>
          <Select placeholder="Select worker"
            showSearch
            optionFilterProp="children"
            filterOption={filterSelectOption}
            filterSort={sortSelectOptions}>
            {commArray.map((item, index) => (
              <Select.Option key={index} value={item.id}>{item.name}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Males" name="countMales">
          <Input placeholder="male count" type="number" id="maleCount" />
        </Form.Item>
        <Form.Item label="Females" name="countFemales">
          <Input placeholder="female count" type="number" id="femaleCount" />
        </Form.Item>
        <Form.Item label="Youths" name="countChildrenYouth">
          <Input placeholder="youth child" type="number" id="youths" />
        </Form.Item>
        <Form.Item label="Number of disabled that attended" name="countDisability">
          <Input placeholder="number of disabled" type="number" id="disabled" />
        </Form.Item>
        <Form.Item label="Number of elderly that attended"
          name={"countElderly"}>
          <Input placeholder="number of elderly" type="number" id="elderly" />
        </Form.Item>
        <Form.Item
          label="Date of Interaction"
          name="dateTime"
          rules={[{ required: true, message: "Choose date of interaction" }]}>
          <DatePicker
            placeholder="select ending date"
            picker={"date"}
            showTime={{ format: 'HH:mm' }}
            //defaultValue={moment('1990-01-01', 'YYYY-MM-DD')}
            className="w-100"
            onChange={onChangeTwo} />

        </Form.Item>
        <Form.Item label="Notes" name="notes">
          <TextArea placeholder="notes" id="notes" />
        </Form.Item>
        <Form.Item label="Commitments" name="commitments">
          <TextArea placeholder="commitments" id="commitments" />
        </Form.Item>
        <Form.Item label="Upload Photo of Participants">
          <Input type="file"
            style={{ width: "100%" }}
            accept="image/*"
            onChange={handleFileUpload}
            placeholder="first image" id="photoParticipants" />
        </Form.Item>
        <Form.Item label="Upload Photo of Attendance List">
          <Input type="file"
            style={{ width: "100%" }}
            accept="image/*"
            onChange={handleFileUpload}
            placeholder="second image" id="photoAttendance" />
        </Form.Item>
        <Form.Item label="Upload Photo Document">
          <Input type="file"
            style={{ width: "100%" }}
            accept="image/*"
            onChange={handleFileUpload}
            placeholder="third image" id="photoDocument" />
        </Form.Item>
        <Button appearance="primary" htmlType="submit" loading={showLoading} disabled={!canCreateInteraction}>
          Create
        </Button>
      </Form>
    </>
  )
}

export default AddInteraction;
